export const __prod__ = import.meta.env.PROD;
export const graphqlAPI = import.meta.env.VITE_GRAPHQL_API as string;
export const restAPI = import.meta.env.VITE_REST_API as string;
export const keycloakURL = import.meta.env.VITE_KEYCLOAK_URL as string;
export const keycloakClientId = import.meta.env
  .VITE_KEYCLOAK_CLIENT_ID as string;
